import { render } from "./region-create.vue?vue&type=template&id=181e0f77"
import script from "./region-create.vue?vue&type=script&lang=js"
export * from "./region-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__